import React from 'react';
import { HOME_SEO } from '../data/dgpt';
import { usePageMeta, canonicalUrl } from '../hooks/usePageMeta';
import { HomeHero } from '../components/home/HomeHero';
import { SampleOutputSection } from '../components/home/SampleOutputSection';
import { HowItWorksSection } from '../components/home/HowItWorksSection';
import { EvidenceSection } from '../components/home/EvidenceSection';
import { WhySection } from '../components/home/WhySection';
import { PositioningSection } from '../components/home/PositioningSection';
import { ToolsGallery } from '../components/home/ToolsGallery';
import { FounderSection } from '../components/home/FounderSection';
import { HomeFaq } from '../components/home/HomeFaq';
import { HomeFinalCta } from '../components/home/HomeFinalCta';
import { MobileStickyCta } from '../components/dgpt/MobileStickyCta';
export function Home() {
  usePageMeta({
    title: HOME_SEO.title,
    description: HOME_SEO.description,
    path: '/',
    keywords: [...HOME_SEO.keywords],
    jsonLd: [{
      '@type': 'SoftwareApplication',
      name: 'DiligenceGPT™',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      url: canonicalUrl('/'),
      description: HOME_SEO.description,
      publisher: {
        '@id': 'https://www.startupfuel.com/#organization'
      }
    }]
  });
  return <>
      <main id="main" data-id="element-563" data-mp="2mz37rildd8f8">
        <HomeHero data-id="element-564" data-mp="2hxnjzirt4nt5" />
        <SampleOutputSection data-id="element-565" data-mp="2hy70cv1t7452" />
        <HowItWorksSection data-id="element-566" data-mp="2hzi4ivz62dwp" />
        <EvidenceSection data-id="element-567" data-mp="2hzqlayyeu3d6" />
        <WhySection data-id="element-568" data-mp="2d6oz05vvj1jk" />
        <PositioningSection data-id="element-569" data-mp="2d65rzk7rhxkb" />
        <ToolsGallery data-id="element-570" data-mp="2d5vz9ovc1cax" />
        <FounderSection data-id="element-571" data-mp="2883zk8og4lw6" />
        <HomeFaq data-id="element-572" data-mp="287cevswe08ko" />
        <HomeFinalCta data-id="element-573" data-mp="288vvxlpvanni" />
      </main>
      <MobileStickyCta data-id="element-574" data-mp="2861dfzqezcwq" />
    </>;
}